import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import api2 from 'store/apis/api2';

export const useHippaLinkValidation = () => {
  const dispatch = useDispatch();

  const [isCheckingLink, setIsCheckingLink] = useState(true);
  const [isLinkExpired, setIsLinkExpired] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authDocumentId = urlParams.get('auth_document') || undefined;
    const signatureToken = urlParams.get('signature_token') || undefined;
    const requestId = urlParams.get('request_id') || undefined;

    const validateHippaLink = async (authDocumentId?: string, signatureToken?: string) => {
      if (!authDocumentId) {
        setIsLinkExpired(true);
        setIsCheckingLink(false);
        return;
      }

      try {
        const res = await api2.get(
          '/api/v2/provider_landing/validate_hippa_link',
          { params: { auth_document: authDocumentId, signature_token: signatureToken, request_id: requestId } },
          true
        )(dispatch, false, true);

        setIsLinkExpired(Boolean(res?.expired));
      } catch (error) {
        console.error('Error validating HIPAA link:', error);
        setIsLinkExpired(true); // fail-safe
      } finally {
        setIsCheckingLink(false);
      }
    };

    validateHippaLink(authDocumentId, signatureToken);
  }, [dispatch]);

  return {
    isCheckingLink,
    isLinkExpired,
  };
};